import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useContext } from "react";
import { UserContext } from "../../context";

const useCompanies = () => {
  const { uploadPhoto, savePhotoUrl, ...others } =
    useColection<Company>("companies");

  const uploadLogo = async (userId: string, file: File) => {
    const logoUrl = await uploadPhoto(userId, file);
    savePhotoUrl(userId, { logo: logoUrl });
  };
  return { ...others, uploadPhoto: uploadLogo };
};

export default useCompanies;
